import { Component, computed, inject, input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';
import { ParentEmptyStateComponent } from '../../../../shared/components/ui/parent-empty-state/parent-empty-state.component';
import { HomeDialogService } from '../../services/home-dialog.service';
import { ParentIdentityService } from '../../../identity/services/parent-identity.service';
import { FamilyKidsService } from '../../../parent-family/services/family-kids.service';

export type HomeEmptyStateContext = 'assignments' | 'courses';

@Component({
  selector: 'app-home-empty-state',
  standalone: true,
  imports: [TranslatePipe, ParentButtonComponent, ParentEmptyStateComponent],
  templateUrl: './home-empty-state.component.html',
  styleUrl: './home-empty-state.component.scss',
})
export class HomeEmptyStateComponent implements OnInit {
  #homeDialogs = inject(HomeDialogService);
  #identity = inject(ParentIdentityService);
  #familyKids = inject(FamilyKidsService);

  context = input<HomeEmptyStateContext>('assignments');
  selectChildScope = input(false);

  readonly children = this.#familyKids.hasChildren;

  readonly showAddKidCta = computed(
    () =>
      this.context() === 'assignments' &&
      !this.children() &&
      !this.selectChildScope() &&
      this.#identity.canExpandFamily(),
  );
  readonly showAddDutyCta = computed(
    () =>
      this.context() === 'assignments' &&
      this.children() &&
      !this.selectChildScope(),
  );

  readonly titleKey = computed(() => {
    if (this.selectChildScope()) {
      return 'app.components.homeEmptyState.assignments.selectChild.title';
    }
    return this.context() === 'courses'
      ? 'app.components.homeEmptyState.courses.title'
      : 'app.components.homeEmptyState.assignments.title';
  });

  readonly subtitleKey = computed(() => {
    if (this.selectChildScope()) {
      return 'app.components.homeEmptyState.assignments.selectChild.subtitle';
    }
    return this.context() === 'courses'
      ? 'app.components.homeEmptyState.courses.subtitle'
      : 'app.components.homeEmptyState.assignments.subtitle';
  });

  readonly ariaLabelKey = computed(() => {
    if (this.selectChildScope()) {
      return 'app.components.homeEmptyState.assignments.selectChild.ariaLabel';
    }
    return this.context() === 'courses'
      ? 'app.components.homeEmptyState.courses.ariaLabel'
      : 'app.components.homeEmptyState.assignments.ariaLabel';
  });

  readonly iconMask = computed(() =>
    this.context() === 'courses'
      ? '/public/svgs/hat-w.svg'
      : '/public/svgs/assign.svg',
  );

  openAddKidDialog(): void {
    this.#homeDialogs.openAddKidDialog();
  }

  ngOnInit(): void {
    void this.#identity.whenConfigReady();
  }

  onAddNewAssignment(): void {
    this.#homeDialogs.openAddDutyDialog();
  }
}
